import { ArrayCreate } from "#packages/ecma262-abstract/ArrayCreate.js";
import "#packages/ecma402-abstract/types/number.js";
import { PartitionNumberPattern } from "#packages/ecma402-abstract/NumberFormat/PartitionNumberPattern.js";
export function FormatNumericToParts(nf, x, implDetails) {
	const parts = PartitionNumberPattern(implDetails.getInternalSlots(nf), x);
	const result = ArrayCreate(0);
	for (const part of parts) {
		result.push({
			type: part.type,
			value: part.value
		});
	}
	return result;
}
